/*
 * @Author: your name
 * @Date: 2021-08-13 17:04:31
 * @LastEditTime: 2025-12-18 18:40:11
 * @LastEditors: daidongyu daidongyu@cnuri.cn
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /my-activation/src/main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import Calendar from "vue2-datepick";
import vueLoading from "vue-loading-template";
import VueBarcode from "@xkeshi/vue-barcode";
import {
  R,
  Request,
  Request1,
  RequestVIP,
  RequestVIP2,
  RequestVIP3,
  RequestMall,
  RequestLocal,
  RequestLocalNew
} from "./page/pagepost";
import Promptbox from "./components/Promptbox";
import loading from "./components/loading";
import longcode from "./components/longcode";
import Return from "./components/Return";
import "../static/iconfont/iconfont.css";
import "lib-flexible";
import wx from "weixin-js-sdk";
import moment from "moment";
import Mint from "mint-ui";
import "mint-ui/lib/style.css";
import "./index.css";
// import './stylemint.css';
// import vConsole from "./vconsole.js";
// console.log("@@@@@@@@@@@@@@");
// console.log(window.onerror);
const edition = 1;
const v = !!localStorage.getItem("clear") ? localStorage.getItem("clear") : 0;
// console.log(v, "vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv");
if (
  !localStorage.getItem("clear") ||
  localStorage.getItem("clear") != Number(edition) + 1
) {
  localStorage.removeItem("Integral");
  localStorage.removeItem("code");
  localStorage.removeItem("payclient");
  localStorage.removeItem("logoUrl");
  localStorage.removeItem("shopID");
  localStorage.removeItem("companyID");
  localStorage.removeItem("shopList");
  localStorage.removeItem("Money");
  localStorage.removeItem("names");
  localStorage.removeItem("VIPNO");
  localStorage.removeItem("appcode");
  localStorage.removeItem("Barcode");

  localStorage.setItem("clear", Number(v) + 1);
  // alert("系统升级，请退出重新进入！");
}

// const businessID = localStorage.getItem("companyID") || window.uri;
// const bundleID = "vip-h5";
// const url = `https://api.cnuri.cn/logpush/api/v1/${businessID}.${bundleID}`;
// fetch(url, {
//   method: "POST", // *GET, POST, PUT, DELETE, etc.
//   mode: "cors", // no-cors, *cors, same-origin
//   cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
//   headers: {
//     "Content-Type": "application/json"
//   },
//   body: JSON.stringify("111111111111") // body data type must match "Content-Type" header
// });

window.onerror = e => {
  console.log(1111111111111111);
  const businessID = localStorage.getItem("companyID") || window.uri;
  const bundleID = "vip-h5";
  const url = `https://api.cnuri.cn/logpush/api/v1/${businessID}.${bundleID}`;
  fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(e) // body data type must match "Content-Type" header
  });
};
// console.log(window.onerror);
// alert("这里是mainjs");
// setInterval(() => {
// console.log(lalalala);
// }, 1000);

Vue.use(Calendar);
Vue.use(Mint);
Vue.use(vueLoading); //注册全局npm组件
Vue.component("barcode", VueBarcode);
Vue.component("Promptbox", Promptbox); //注册全局组件
Vue.component("loading", loading);
Vue.component("longcode", longcode);
Vue.component("Return", Return);
Vue.prototype.R = R; //注册全局js组件
Vue.prototype.Request = Request;
Vue.prototype.Request1 = Request1;
Vue.prototype.RequestVIP = RequestVIP;
Vue.prototype.RequestVIP2 = RequestVIP2;
Vue.prototype.RequestVIP3 = RequestVIP3;
Vue.prototype.RequestMall = RequestMall;
Vue.prototype.RequestLocal = RequestLocal;
Vue.prototype.RequestLocalNew = RequestLocalNew;

Vue.prototype.WX = wx; // 引入jssdk
Vue.config.productionTip = false;
Vue.prototype.moment = moment;

// 将 Mint UI 暴露到 window，供版本检测等工具使用
window.MINT = Mint;

// 页面修改时修改浏览器标签栏
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js